import React from 'react';
import { Container } from '../ui/Container';
import { ShieldCheck, RefreshCw, Eye, Clock } from 'lucide-react';
export function GuaranteeStrip() {
  const guarantees = [{
    icon: ShieldCheck,
    text: 'Quality Guarantee',
    sub: 'Premium materials'
  }, {
    icon: RefreshCw,
    text: 'Free Reprints',
    sub: 'If not satisfied'
  }, {
    icon: Eye,
    text: 'Free Digital Proof',
    sub: 'Before we print'
  }, {
    icon: Clock,
    text: 'Same-Day Quotes',
    sub: 'Fast turnaround'
  }];
  return <div className="bg-gray-900 py-8 border-t-4 border-cyan-500" data-id="element-231">
      <Container data-id="element-232">
        <div className="grid grid-cols-2 md:grid-cols-4 gap-6" data-id="element-233">
          {guarantees.map((item, index) => <div key={index} className="flex items-center gap-3 group" data-id="element-234">
              <div className="p-3 rounded-full bg-gray-800 group-hover:bg-cyan-900 transition-colors border border-gray-700 group-hover:border-cyan-700" data-id="element-235">
                <item.icon className="h-6 w-6 text-cyan-400 group-hover:text-cyan-300 transition-colors" data-id="element-236" />
              </div>
              <div data-id="element-237">
                <div className="font-bold text-white text-sm md:text-base" data-id="element-238">
                  {item.text}
                </div>
                <div className="text-gray-400 text-xs" data-id="element-239">{item.sub}</div>
              </div>
            </div>)}
        </div>
      </Container>
    </div>;
}